import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {useNavigate, useParams} from "react-router-dom";
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {Tooltip} from "primereact/tooltip";
import {ConfirmDialog} from "primereact/confirmdialog";
import {addLocale, locale} from "primereact/api";
import {InputText} from "primereact/inputtext";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";
import {Badge} from "primereact/badge";
import moment from "moment/moment";

const _FM_AccommodationpreparationListComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id,action} = useParams();
  const [accommodationpreparation, setAccommodationpreparation] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: Number(localStorage.getItem('accommodationpreparation_first')) || 0,
    rows: Number(localStorage.getItem('accommodationpreparation_rows')) || rows,
    page: Number(localStorage.getItem('accommodationpreparation_page')) || 0,
    sortField: localStorage.getItem('accommodationpreparation_sortField') || 'is_completed',
    sortOrder: Number(localStorage.getItem('accommodationpreparation_sortOrder')) || 1,
    filters: JSON.parse(localStorage.getItem('accommodationpreparation_filters')) || null,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      window.App.setState({rerenderAccommodationpreparationList: false})
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation-preparation-task-list" + query,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setAccommodationpreparation(response.data.data.items);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', accommodationpreparationSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    />
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', accommodationpreparationSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className="p-button-sm p-button-secondary p-mr-2"
                tooltip={t('show')}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  navigate('/accommodation-preparation/read/' + rowData.id)
                }}/>
        <Button icon="pi pi-pencil" className="p-button-sm  p-button-warning p-mr-2"
                tooltip={t('edit')}
                disabled={rowData.is_completed === true}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  navigate('/accommodation-preparation/update/' + rowData.id)
                }}/>
      </React.Fragment>
    );
  }

  addLocale('default', {
    clear: t('filter_clear'),
    apply: t('filter_apply'),
  });
  locale('default');

  useEffect(() => {
    if (lazyParams.filters) {
      document.getElementById('search').value = '';
      localStorage.setItem('accommodationpreparation_filters', JSON.stringify(lazyParams.filters))
      if (lazyParams.sortField) {
        localStorage.setItem('accommodationpreparation_sortField', lazyParams.sortField)
      }
      if (lazyParams.sortOrder) {
        localStorage.setItem('accommodationpreparation_sortOrder', lazyParams.sortOrder)
      }
      if (lazyParams.first >= 0) {
        localStorage.setItem('accommodationpreparation_first', lazyParams.first)
      }
      if (lazyParams.page >= 0) {
        localStorage.setItem('accommodationpreparation_page', lazyParams.page)
      }
      if (lazyParams.rows) {
        localStorage.setItem('accommodationpreparation_rows', lazyParams.rows)
        setRows(lazyParams.rows)
      }
    }
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderAccommodationpreparationList === true])

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-4 p-col-align-center"}>
          <h2 className={"p-m-0"}>{t('accommodationpreparation_list')}</h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <HelpComponent type={"site"} position={"UNDER_HELP_BUTTON"}/>
          {localStorage.getItem('accommodationpreparation_filters') &&
            <a style={{color: "red"}} className={"p-button p-button-danger p-ml-2"}
               onClick={() => {
                 localStorage.removeItem('accommodationpreparation_filters')
                 localStorage.removeItem('accommodationpreparation_sortField')
                 localStorage.removeItem('accommodationpreparation_sortOrder')
                 localStorage.removeItem('accommodationpreparation_rows')
                 localStorage.removeItem('accommodationpreparation_page')
                 localStorage.removeItem('accommodationpreparation_first')
                 setLazyParams({
                   ...lazyParams,
                   filters: null
                 })
               }}
            >
              <i className={"pi pi-exclamation-triangle"}></i>&nbsp;{t('clear_filter')}
            </a>
          }
          {/*{lazyParams && lazyParams.is_active === 0 ? (*/}
          {/*  <Button type="button" icon={"pi pi-eye-slash"}*/}
          {/*          label={t('hide_deleted')}*/}
          {/*          onClick={() => {*/}
          {/*            let _lazyParams = lazyParams*/}
          {/*            delete lazyParams.is_active*/}
          {/*            setLazyParams(_lazyParams)*/}
          {/*            loadLazyData()*/}
          {/*          }}*/}
          {/*          className="p-button-danger p-ml-2"/>*/}
          {/*) : (*/}
          {/*  <Button type="button" icon={"pi pi-eye"}*/}
          {/*          label={t('show_deleted')}*/}
          {/*          onClick={() => {*/}
          {/*            setLazyParams({*/}
          {/*              ...lazyParams,*/}
          {/*              is_active: 0*/}
          {/*            })*/}
          {/*          }}*/}
          {/*          className="p-button-success p-ml-2"/>*/}
          {/*)}*/}
          <span className="p-input-icon-left p-ml-2">
              <i className="pi pi-search"/>
              <InputText id="search"
                         placeholder={t('search')}
                         onChange={(e) => {
                           clearTimeout(window.searchTimeout)
                           window.searchTimeout = setTimeout(function () {
                             localStorage.removeItem('accommodationpreparation_filters')
                             localStorage.removeItem('accommodationpreparation_sortField')
                             localStorage.removeItem('accommodationpreparation_sortOrder')
                             localStorage.removeItem('accommodationpreparation_rows')
                             localStorage.removeItem('accommodationpreparation_page')
                             localStorage.removeItem('accommodationpreparation_first')
                             setLazyParams({
                               ...lazyParams,
                               genericSearch: e.target.value,
                               filters: null
                             })
                           }, 1000)
                         }}
                         className={""}
              />
            </span>
        </div>
      </div>
      {/* <HelpComponent type={"list_box"} box={"accommodation-preparation-task-list"}/> */}
      <DataTable
        ref={dt}
        size={"small"}
        emptyMessage={t('empty_message')}
        value={accommodationpreparation} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows}
        autoLayout={true}
        filterDisplay="menu"
        responsiveLayout={window.App.state.responsiveLayout}
        breakpoint="1365px"
        stripedRows
        dataKey="id"
        selectionMode={"single"}
        onRowDoubleClick={(rowData) => {
          if(!rowData.data.deleted_at_snapshot && rowData.data.is_completed === false)
            navigate('/accommodation-preparation/update/' + rowData.data.id)
        }}
      >
        
        <Column field="is_completed" header={t('completed')} sortable className={"p-text-left"} body={(rowData) => {
          return (
            <>
              {rowData.is_completed === true ? (
                <i className={"pi pi-check text-success"}></i>
              ) : (
                <i className={"pi pi-times text-danger"}></i>
              )}
            </>
          )
        }}
        ></Column>
        <Column field="residential_unit.name" header={t('residential_unit')}
                body={(rowData) => {
                  return (
                    <>
                      {rowData.residential_unit.name}
                      {/*{rowData?.residential_unit?.is_ready === true ? (*/}
                      {/*  <Badge severity="success" style={{height: '8px', width: '8px', minWidth: '8px', position: 'relative', top: '-5px', left: '5px'}}></Badge>*/}
                      {/*) : (*/}
                      {/*  <Badge severity="danger"  style={{height: '8px', width: '8px', minWidth: '8px', position: 'relative', top: '-5px', left: '5px'}}></Badge>*/}
                      {/*)}*/}
                    </>
                  )
                }}
        ></Column>
        <Column field="reservation.association_code" header={t('reservation')}
                body={(rowData) => {
                  if(rowData?.reservation?.association_code) {
                    return (
                      <>
                        <span className={"tt-association-code-accommodation-list-info-" + rowData?.reservation?.id + " p-mr-2"}
                              data-pr-tooltip={rowData?.reservation?.association_code}>
                          <i className={"pi pi-info-circle"} style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                        </span>
                        <Tooltip target={".tt-association-code-accommodation-list-info-" + rowData?.reservation?.id}/>
                        <span className={"p-badge"}
                              style={{
                                fontSize: '1rem',
                                backgroundColor: rowData?.reservation?.status
                                  ? rowData?.reservation?.status?.toLowerCase() === 'pending'
                                    ? '#dddddd'
                                    : rowData?.reservation?.status?.toLowerCase() === 'confirmed'
                                      ? '#f1eea5'
                                      : rowData?.reservation?.status?.toLowerCase() === 'cancelled'
                                        ? '#f7a2a2'
                                        : rowData?.reservation?.status?.toLowerCase() === 'checked_in'
                                          ? '#3ec0e9'
                                          : rowData?.reservation?.status?.toLowerCase() === 'checked_out'
                                            ? '#0abb87'
                                            : rowData?.reservation?.status?.toLowerCase() === 'no_show'
                                              ? '#8a2be2'
                                              : '#ccc'
                                  : undefined,
                                color: rowData?.reservation?.status
                                  ? rowData?.reservation?.status?.toLowerCase() === 'pending' || rowData?.reservation?.status?.toLowerCase() === 'confirmed'
                                    ? '#5f656b'
                                    : rowData?.reservation?.status?.toLowerCase() === 'no_show'
                                      ? '#fff'
                                      : undefined
                                  : undefined
                        }}>
                          {rowData?.reservation?.association_code?.split(' | ').pop()?.trim()}
                        </span>
                      </>
                    )
                  }
                }}
        ></Column>
        <Column field="created_at_snapshot" sortable header={t('created_at')}
                body={(rowData) => {
                  if (rowData.created_at_snapshot !== null) {
                    return (
                      <span>{moment.utc(rowData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                    )
                  }
                }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap p-text-right"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(_FM_AccommodationpreparationListComponent);
